import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { HttpClient } from '@angular/common/http';
import * as fromOrderAction from '../action/order.action';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { IError } from '../state/app.state';
import { AppToastrService } from '@app/@core/services/toastr/app-toastr.service';
import { OrdersService } from '@app/orders/services/orders.service';
import { IOrderListResponse, IOrderData } from '@app/@shared/Models/order.model';

@Injectable()
export class OrderEffect {
    constructor(private http: HttpClient, private action$: Actions, private appToastrService: AppToastrService, private ordersService: OrdersService) { }
    GetOrderItemList$: Observable<Action> = createEffect(() =>
        this.action$.pipe(
            ofType(fromOrderAction.BeginGetOrderdItems),
            mergeMap((action: any) =>
                this.ordersService.getOrderList(action.requestBody).pipe(
                    map((response: IOrderListResponse) => {
                        if (response) {
                            let listItems: IOrderData = response.data;
                            return fromOrderAction.GetOrderdItemsSuccess({ payload: listItems });
                        }
                    }),
                    catchError((error) => {
                        let mappedData: IError = { statusCode: error.status, errorMessage: error.message }
                        return of(fromOrderAction.GetOrderdItemError({ payload: mappedData }));
                    })
                )
            )
        )
    )
}